import { GlobalHelper } from '../GlobalHelper';
import utils = egr.wcf.utils;

interface WSAttachment {
    filename: string;
    mimetype: string;
    content: string;
    base64encoded: boolean;
}

interface WSMessage {
    subject: string;
    htmlContent?: string;
    textContent?: string;
    multipart: boolean;
    attachments: Array<WSAttachment>;
    captchaToken?: string;
    to?: Array<string>;
}

export interface Attachment {
    filename: string;
    mimetype: string;
    content: string | ArrayBuffer;
}

export interface Message {
    subject: string;
    htmlContent?: string;
    textContent?: string;
    attachments: Array<Attachment>;
    captchaToken?: string;
    to?: Array<string>;
}

export abstract class MailPlugin {
    public static async sendMessage(mailConfig: string, message: Message): Promise<void> {
        const url: string = GlobalHelper.articleManager.session.baseUrl + '/EAIWS/plugins/Mail/' + mailConfig;
        await utils.async.ajax(
            'POST',
            url,
            JSON.stringify(MailPlugin.convertMessage(message)),
            {
                dataType: 'text',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }
        );
    }

    private static convertMessage(message: Message): WSMessage {
        return {
            subject: message.subject,
            htmlContent: message.htmlContent,
            textContent: message.textContent,
            multipart: !(
                (
                    utils.string.isNullOrEmpty(message.htmlContent) ||
                    utils.string.isNullOrEmpty(message.textContent)
                ) && (
                    message.attachments == null ||
                    message.attachments.length === 0
                )
            ),
            attachments: message.attachments != null ? message.attachments.map(MailPlugin.convertAttachment) : [],
            captchaToken: message.captchaToken,
            to: message.to,
        };
    }

    private static convertAttachment(attachment: Attachment): WSAttachment {
        if (attachment.content instanceof ArrayBuffer) {
            return {
                filename: attachment.filename,
                mimetype: attachment.mimetype,
                content: utils.arraybuffer.toBase64(attachment.content),
                base64encoded: true
            };
        }

        return {
            filename: attachment.filename,
            mimetype: attachment.mimetype,
            content: attachment.content,
            base64encoded: false
        };
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/webservices/MailPlugin.ts